import OEToolbox from '../../../lib/tools/oe-toolbox';
import {OEObjectModelValueTypes} from '../../elements/object-model-value-edit/oe-object-model-value-edit-model';

export const OEUserObjectChangeFlags = {
    none:                       0,
    geometry:                   1,
    material:                   2,
    transform:                  4,
    texture:                    8,
    properties:                 16,
    name:                       32,
    all:                        63
};

export const OEUserObjectGeometryType = {
    panel:                      0,
    box:                        1,
    sphere:                     2,
    ellipsoid:                  3,
    plane:                      4,
    ellipse:                    5,
    default:                    0
};

export const OEUserObjectPropertyFlags = {
    none:                       0,
    disableHighlighting:        1,
    passthrough:                2,
    cameraPivot:                4,
    default:                    0
};

export const OEUserObjectDataFlags = {
    none:                       0,
    geometry:                   1,
    transform:                  2,
    material:                   4,
    properties:                 8,
    name:                       16,
    all:                        31
};

export const OEUserObjectToolbox = {

    createGeometryTypeEntries()   {
        return Object.keys(OEUserObjectGeometryType).filter(key => key !== 'default').map(key => {
            return {
                type: OEUserObjectGeometryType[key],
                key: key,
                label: OEToolbox.capitalize(key)
            };
        });
    },

    toString(geometryType)  {
        let array = Object.keys(OEUserObjectGeometryType);
        if(typeof(geometryType) != 'number' || geometryType < 0 || geometryType >= array.length)  return;
        return array[geometryType];
    },

    materialCount(geometryType) {
        if([OEUserObjectGeometryType.panel].includes(geometryType)) {
            return 2;
        } else if([OEUserObjectGeometryType.box, OEUserObjectGeometryType.sphere, OEUserObjectGeometryType.ellipsoid, OEUserObjectGeometryType.plane, OEUserObjectGeometryType.ellipse].includes(geometryType)) {
            return 1;
        }
        return 0;
    }
};

export const OEUserObjectParameterModels = {

    panel: {
        width: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        height: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        thickness: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001}
    },

    box: {
        width: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        height: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        depth: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001}
    },

    sphere: {
        radius: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001}
    },

    ellipsoid: {
        a: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        b: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        c: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001}
    },

    plane: {
        width: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        height: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        cornerRadius: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0, max: 1000, step: 0.001}
    },

    ellipse: {
        a: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001},
        b: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.01, max: 1000, step: 0.001}
    },

    modelForGeometryType(type)   {
        let str = OEUserObjectToolbox.toString(type);
        return str && this[str] ? this[str] : {};
    },

    transformation: {
        position: {type: OEObjectModelValueTypes.vec3, allowUndefined: false, step: 0.001},
        rotation: {type: OEObjectModelValueTypes.vec3, allowUndefined: false, step: 0.001}
    },

    combinedMaterial: {
        alpha: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, max: 1.0, step: 0.001},
    },

    material: {
        diffuse: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, max: 1.5, step: 0.001},
        ambient: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, max: 1.5, step: 0.001},
        specBrightness: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.0, max: 1.0, step: 0.001},
        roughness: {type: OEObjectModelValueTypes.float, allowUndefined: false, min: 0.001, max: 0.5, step: 0.001}
    }
};

export const OEUserObjectPopoverBtnIds = {
    alignToCamera:              'alignToCamera',
    alignToCameraVPMainAxis:    'alignToCameraVPMainAxis',
    loadTexture:                'loadTexture',
    dumpTexture:                'dumpTexture',
    highlightingProperty:       'highlightingProperty',
    passthroughProperty:        'passthroughProperty',
    cameraPivot:                'cameraPivot',
    copyGeometry:               'copyGeometry',
    pasteGeometry:              'pasteGeometry',
    copyTransformation:         'copyTransformation',
    pasteTransformation:        'pasteTransformation'
};

export const OEUserObjectDataSlots = {
    geometry:                   0,
    transformation:             1
};